module.exports = __webpack_public_path__ + "static/media/star5.6857e232.svg";